import UITable from './table.vue';
import TableBody from './table-body.vue';
import TableCell from './table-cell.vue';
import TableContainer from './table-container.vue';
import TableHead from './table-head.vue';
import TableHeader from './table-header.vue';
import TableRow from './table-row.vue';
export { UITable, TableBody, TableCell, TableContainer, TableHead, TableRow, TableHeader };
